import { render, staticRenderFns } from "./course-details.vue?vue&type=template&id=115b389c&scoped=true&"
import script from "./course-details.ts?vue&type=script&lang=ts&"
export * from "./course-details.ts?vue&type=script&lang=ts&"
import style0 from "./course-details.scss?vue&type=style&index=0&id=115b389c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b389c",
  null
  
)

export default component.exports